import { render, staticRenderFns } from "./u-tab-button.vue?vue&type=template&id=cd925680&scoped=true&"
import script from "./u-tab-button.vue?vue&type=script&lang=js&"
export * from "./u-tab-button.vue?vue&type=script&lang=js&"
import style0 from "./u-tab-button.vue?vue&type=style&index=0&id=cd925680&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd925680",
  null
  
)

export default component.exports